import { render } from "./AuTabView.vue?vue&type=template&id=83c28a5c&scoped=true"
import script from "./AuTabView.vue?vue&type=script&lang=js"
export * from "./AuTabView.vue?vue&type=script&lang=js"

import "./AuTabView.vue?vue&type=style&index=0&id=83c28a5c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c28a5c"]])

export default __exports__